import React from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

interface TrainingContentViewProps {
  html: string;
}

const TrainingContentView: React.FC<TrainingContentViewProps> = ({ html }) => {
  if (!html.trim()) {
    return (
      <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)' }}>
        아직 작성된 본문이 없습니다.
      </p>
    );
  }

  return (
    <>
      <div
        className="training-content-view"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
        style={{
          fontSize: '15px',
          lineHeight: 1.75,
          color: 'var(--Color-text-normal)',
          wordBreak: 'break-word',
        }}
      />
      <style>{`
        .training-content-view h2 {
          font-size: 1.25rem;
          font-weight: 700;
          margin: 1.5em 0 0.6em;
          color: var(--Color-text-strong);
        }
        .training-content-view h3 {
          font-size: 1.1rem;
          font-weight: 600;
          margin: 1.25em 0 0.5em;
          color: var(--Color-text-strong);
        }
        .training-content-view p {
          margin: 0.6em 0;
        }
        .training-content-view ul,
        .training-content-view ol {
          margin: 0.6em 0;
          padding-left: 1.5em;
        }
        .training-content-view a {
          color: var(--Color-fill-brand-color);
          text-decoration: underline;
        }
        .training-content-view img {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          margin: 12px 0;
        }
        .training-content-view blockquote {
          margin: 12px 0;
          padding: 12px 16px;
          border-left: 4px solid var(--Color-fill-brand-color);
          background: var(--Color-fill-hover);
          border-radius: 0 8px 8px 0;
        }
      `}</style>
    </>
  );
};

export default TrainingContentView;
